module.exports = __webpack_public_path__ + "static/img/ying.6c529bc0.png";